
export class Response {
    constructor(fetchResponse) {
        this.fetchResponse = fetchResponse
    }

    async json() {
        return await this.fetchResponse.json()
    }
}